// console.log("Lazy Loading Init");

// Fix: Polaris renders itself as <dialog id="polaris-consent-widgets"> with
// inline z-index:999999 and the theme's CSS makes all dialogs position:fixed
// covering the full viewport. This makes it non-modal (so it stops blocking
// the page) and collapses it to only its natural height at the bottom.
(function () {
  function fixPolarisDialog() {
    var dialog = document.querySelector('dialog#polaris-consent-widgets');
    if (!dialog) return;

    // If opened as a modal (top layer), convert to non-modal.
    // Some engines reject the ':modal' selector and throw a SyntaxError from
    // matches() rather than returning false. Probe it defensively and treat a
    // throw as "not modal", so the positioning below always runs.
    var isModal = false;
    try {
      isModal = typeof dialog.matches === 'function' && dialog.matches(':modal');
    } catch (e) {
      isModal = false;
    }

    if (isModal) {
      try {
        dialog.close();
        dialog.show();
      } catch (e) {}
    }

    // Force the dialog to only occupy its natural height at the bottom
    dialog.style.setProperty('position', 'fixed', 'important');
    dialog.style.setProperty('top', 'auto', 'important');
    dialog.style.setProperty('bottom', '0', 'important');
    dialog.style.setProperty('left', '0', 'important');
    dialog.style.setProperty('right', '0', 'important');
    dialog.style.setProperty('height', 'auto', 'important');
    dialog.style.setProperty('max-height', 'none', 'important');
    dialog.style.setProperty('width', '100%', 'important');
    dialog.style.setProperty('pointer-events', 'auto', 'important');
  }

  // Watch only for the dialog being added, then observe that node.
  // A document-wide attribute observer runs on every style change.
  function watchDialog(dialog) {
    fixPolarisDialog();
    var dialogObserver = new MutationObserver(fixPolarisDialog);
    dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open', 'style'] });
  }

  var existingDialog = document.querySelector('dialog#polaris-consent-widgets');
  if (existingDialog) {
    watchDialog(existingDialog);
  } else {
    var observer = new MutationObserver(function () {
      var dialog = document.querySelector('dialog#polaris-consent-widgets');
      if (!dialog) return;
      observer.disconnect();
      watchDialog(dialog);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.lazy-image').forEach(img => {
        img.classList.remove('lazy-image');
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
    });

    document.querySelectorAll('.lazy-image--backfill').forEach(img => {
        img.classList.remove('lazy-image--backfill');
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
    });
});

